var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.9,
    height: 19.9,
    viewBox: "0 0 19.9 19.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path_1034",
    "data-name": "path 1034",
    d: "M21.011,18.617a8.788,8.788,0,1,0-2.394,2.394l3.323,3.323a1.693,1.693,0,0,0,2.394-2.394Zm-7.286,1.856a6.749,6.749,0,1,1,6.749-6.749A6.749,6.749,0,0,1,13.724,20.473Z",
    transform: "translate(-4.929 -4.929)",
    fill: "#5a5a5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9e415ceff5df888968ec0334161731d4.svg";
export { ForwardRef as ReactComponent };